import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HotelResponse } from './models/response/hotel.response';
import { RequestState } from '@shared/models/request-state';
import { environment } from '@environments/environment';
import { ApiCacheService } from '@shared/services/api-cache.service';
import { HotelRequest } from './models/request/hotel.request';

@Injectable({
  providedIn: 'root',
})
export class HotelService {
  private readonly _url = `${environment.apiUrl}hotel`;

  constructor(private cacheService: ApiCacheService) {}

  getHotel(
    request: HotelRequest,
    isRefresh = false,
  ): Observable<RequestState<HotelResponse>> {
    // return of(
    //   new RequestState<HotelResponse>(RequestStatus.IsCompleteNoResponse),
    // );
    const cacheId = this.getCacheId(request);
    // const url = `${this._url}?employeeNumber=${request.employeeNumber}&start=${request.start}&end=${request.end}`;
    const url = `${this._url}?start=${request.start}&end=${request.end}`;

    if (isRefresh) {
      return this.cacheService.forceRefreshGet<HotelResponse>(cacheId, url);
    }

    return this.cacheService.request<HotelResponse>(cacheId, url);
  }

  private getCacheId(hotelRequest: HotelRequest): string {
    return `hotel-${hotelRequest.start}/${hotelRequest.end}`;
  }
}
